import classNames from 'classnames';
import s from './Drawing.module.css'
import Tooltip from '@UI/Tooltip';
import Preloader from '@UI/Preloader';
import { IcoRemove } from '@/utils/icons';

const DrawingImage = ({
    changeImage, imageUrl, setBrushColor, setBrushWidth, brushWidth, setIsTextRegim, changeCanvasFont, isSaving,
    isTextRegim, showCanvasText, saveCanvasText, canvasFont, startDrawing, draw, brushColor, undoLastAction,
    increaseScale, canvasRef, decreaseScale, handleSaveImage, loading, resetCanvas, stopDrawing, addText,
    canvasStyle, xY, canvasText, setCanvasText,
    title,
    tooltip,
    showResetCanvas = true
}) => {
    return (
        <div style={{ width: '100%' }} className={classNames({ [s.displayNone]: !changeImage })}>
            <div className={classNames(s.canvasManage)}>
            
                {!imageUrl && <div className={s.tooltipWrapper}>
                {
                    !!title && <span className={s.textСlueBig}>{title}</span>
                }
                {
                    !!tooltip && (
                        <Tooltip 
                            text={tooltip} 
                            width={220} />
                    )
                }
                    </div>
                }
                <button 
                    className='backgroundNewGrey'
                    onClick={undoLastAction}>Отменить последнее действие</button>
                <div className={s.inputWrapper}>
                    <span className={s.textСlue}>Выберите цвет кисточки и текста</span>
                    <input
                    type="color"
                    value={brushColor}
                    onChange={(e) => setBrushColor(e.target.value)}
                    />
                </div>
                <div className={s.inputWrapper}>
                    <span className={s.textСlue}>Выберите ширину кисточки</span>
                    <input
                    type="range"
                    min="1"
                    max="15"
                    value={brushWidth}
                    onChange={(e) => setBrushWidth(e.target.value)}
                    />
                </div>
                <div className={s.inputsWrapper}>
                    <button
                    onClick={increaseScale} 
                    className={classNames('backgroundNewGrey', { [s.buttonDisable]: canvasRef?.current?.width > 1000 }, { [s.buttonDisable]: !imageUrl })}>Увеличить изображение</button>
                    <button 
                        onClick={decreaseScale}
                        className={classNames('backgroundNewGrey', { [s.buttonDisable]: canvasRef?.current?.width < 450 }, { [s.buttonDisable]: !imageUrl })}>Уменьшить изображение</button>
                    <button 
                    onClick={()=>setIsTextRegim(regim => !regim)}
                    className="backgroundNewGrey">
                        { isTextRegim? 'Выключить текстовый режим': 'Включить текстовый режим' }
                    </button>
                    <div className={s.inputWrapper}>
                    <span className={s.textСlue}>Размер шрифта</span>
                    <input
                        type="range"
                        min="10"
                        max="50"
                        className={s.canvasInputFont}
                        value={canvasFont}
                        onChange={(e)=>changeCanvasFont(e.target.value)}
                    />
                    </div>
                </div> 
                {
                    handleSaveImage?.f && handleSaveImage?.text && (
                        <button 
                            className={classNames('backgroundNewGrey', 'backgroundNewYellow', { [s.buttonDisable]: !imageUrl || isSaving })}
                            onClick={handleSaveImage?.f}>{handleSaveImage?.text}</button>
                    )
                }
                
            </div>
            
            <div className={classNames(s.canvasAndIcoRemove, { [s.displayNone]: !imageUrl }, 'customScroll')}>
                <div className={classNames(s.preloader, {[s.displayNone]: !loading })}>
                    <Preloader fullScreen='center' />
                </div>
                {
                    showResetCanvas && <div className={s.remove} onClick={resetCanvas}><IcoRemove /></div>
                }
                
                <canvas
                    ref={canvasRef}
                    className={classNames(s.canvas)}
                    onMouseDown={startDrawing}
                    onMouseMove={draw}
                    onMouseUp={stopDrawing}
                    onMouseOut={stopDrawing}
                    onTouchStart={startDrawing} 
                    onTouchMove={draw} 
                    onTouchEnd={stopDrawing} 
                    onTouchCancel={stopDrawing}
                    onClick={addText}
                    { ...canvasStyle }
                />
                {
                    isTextRegim && <div style={{
                        top: xY.offsetY,
                        left: xY.offsetX,
                        display: showCanvasText?'flex':'none',
                        flexDirection: 'column',
                        alignItems:'flex-start',
                        position: 'absolute'
                    }}>
                        <textarea
                            value={canvasText}
                            onChange={(e)=>setCanvasText(e.target.value)}
                            onBlur={saveCanvasText}
                            style={{
                                minHeight:'90px',
                                color: brushColor,
                                fontSize: canvasFont + 'px'
                            }}
                            className={s.inputText}
                        />
                        <button style={{marginTop:'5px'}} className='backgroundNewGrey backgroundNewYellow'>Ок</button>
                    </div>
                }
            </div>
        </div>
    )
}
export default DrawingImage;
